import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { useAccessibility } from '../hooks/nativeAccessibilityHelper';
export const WixProGalleryWithAccessability = WixProGallery => props => {
  const isAccessibilityEnabled = !props.disableAccessibilityHelper;
  const _useAccessibility = useAccessibility(isAccessibilityEnabled),
    isAccessible = _useAccessibility.isAccessible;
  return /*#__PURE__*/React.createElement(WixProGallery, _extends({}, props, {
    isAccessible: isAccessible
  }));
};
//# sourceMappingURL=withAccessibility.js.map